import { createContext, useContext, useState } from "react";

const ReportContext = createContext({});

export default function ReportContextProvider({ children }) {
  const [report, setReport] = useState({});
  const [section, setSection] = useState("performance-dashboard");
  const [cat, setCat] = useState([]);
  const [subCat, setSubCat] = useState([]);
  const [type, setType] = useState([]);

  const [selectedCat, setSelectedCat] = useState([]);
  const [selectedSubCat, setSelectedSubCat] = useState([]);
  const [selectedType, setSelectedType] = useState([]);

  const generateTags = (reportData) => {
    if (
      reportData.hasOwnProperty("kwtrends") &&
      reportData.hasOwnProperty("kwdates") &&
      reportData.kwtrends.length !== 0 &&
      reportData.kwdates.length !== 0
    ) {
      const uniqueTags = reportData.kwtrends.reduce(
        (acc, row) => {
          if (!acc.cat.includes(row["Tag 1"])) {
            acc.cat.push(row["Tag 1"]);
          }
          if (!acc.subCat.includes(row["Tag 2"])) {
            acc.subCat.push(row["Tag 2"]);
          }
          if (!acc.type.includes(row["Tag 3"])) {
            acc.type.push(row["Tag 3"]);
          }
          return acc;
        },
        { cat: [], subCat: [], type: [] }
      );

      uniqueTags.cat.sort();
      uniqueTags.subCat.sort();
      uniqueTags.type.sort();

      setCat(uniqueTags.cat);
      setSubCat(uniqueTags.subCat);
      setType(uniqueTags.type);
    }
  };

  const generateHcs = (reportData) => {
    if (
      reportData.hasOwnProperty("kwtrends") &&
      reportData.hasOwnProperty("kwdates") &&
      reportData.kwtrends.length !== 0 &&
      reportData.kwdates.length !== 0
    ) {
      // console.log('ddddd')
      const filteredKwTrends = reportData.kwtrends.filter((row) => {
        const catMatch =
          selectedCat.length > 0 ? selectedCat.includes(row["Tag 1"]) : true;
        const subCatMatch =
          selectedSubCat.length > 0
            ? selectedSubCat.includes(row["Tag 2"])
            : true;
        const typeMatch =
          selectedType.length > 0 ? selectedType.includes(row["Tag 3"]) : true;
        return catMatch && subCatMatch && typeMatch;
      });
      const getFullMonthName = (shortMonthYear) => {
        const [shortMonth] = shortMonthYear.split("-");
        const date = new Date(`${shortMonth} 1, 2000`);
        return date.toLocaleString("default", { month: "long" });
      };
      const kwTrendsSum = reportData.kwdates.reduce((acc, date, index) => {
        const yearIndex = Math.floor(index / 12);
        const monthName = getFullMonthName(date);

        if (!acc[monthName]) {
          acc[monthName] = { month: monthName, last: 0, previous: 0 };
        }

        filteredKwTrends.forEach((row) => {
          const value = parseFloat(row[date]) || 0;
          if (yearIndex === 0) {
            acc[monthName].previous += value;
          } else {
            acc[monthName].last += value;
          }
        });

        return acc;
      }, {});

      const totalMonthlySearches = Object.values(kwTrendsSum).map((item) => ({
        ...item,
        yoy:
          item.last !== 0
            ? parseFloat(
                DecPrec.toFixed(
                  ((item.last - item.previous) / item.previous) * 100,
                  2
                )
              )
            : 0,
      }));
      reportData.hcs_total_searches = totalMonthlySearches;
      // console.log('reportData', reportData.hcs_total_searches[0])
    }
    setReport({ ...reportData });
    // setSelectedCat([...selectedCat]);
  };

  return (
    <ReportContext.Provider
      value={{
        report,
        setReport,
        section,
        setSection,
        generateHcs,
        generateTags,
        cat,
        subCat,
        type,
        selectedCat,
        selectedSubCat,
        selectedType,
        setSelectedCat,
        setSelectedSubCat,
        setSelectedType,
      }}
    >
      {children}
    </ReportContext.Provider>
  );
}

export function useReportContext() {
  const report = useContext(ReportContext);

  if (!report) {
    throw new Error(
      "useReportContext must be used within a ReportContextProvider."
    );
  }

  return report;
}

var DecPrec = (function () {
  if (Number.EPSILON === undefined) {
    Number.EPSILON = Math.pow(2, -52);
  }
  if (Math.sign === undefined) {
    Math.sign = function (x) {
      return (x > 0) - (x < 0) || +x;
    };
  }
  return {
    // Decimal round (half away from zero)
    round: function (num, decimalPlaces) {
      var p = Math.pow(10, decimalPlaces || 0);
      var n = num * p * (1 + Number.EPSILON);
      return Math.round(n) / p;
    },
    // Decimal ceil
    ceil: function (num, decimalPlaces) {
      var p = Math.pow(10, decimalPlaces || 0);
      var n = num * p * (1 - Math.sign(num) * Number.EPSILON);
      return Math.ceil(n) / p;
    },
    // Decimal floor
    floor: function (num, decimalPlaces) {
      var p = Math.pow(10, decimalPlaces || 0);
      var n = num * p * (1 + Math.sign(num) * Number.EPSILON);
      return Math.floor(n) / p;
    },
    // Decimal trunc
    trunc: function (num, decimalPlaces) {
      return (num < 0 ? this.ceil : this.floor)(num, decimalPlaces);
    },
    // Format using fixed-point notation
    toFixed: function (num, decimalPlaces) {
      return this.round(num, decimalPlaces).toFixed(decimalPlaces);
    },
  };
})();
